import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ColDef, ICellRendererParams } from '@ag-grid-community/core';
import { LinkableIconRenderer } from './linkable-icon-renderer';

@Component({
    selector: 'entity-linkable-icon-renderer',
    template: `
        <p-link
            fxFill
            fxLayout="row"
            fxLayoutAlign="center center"
            *ngIf="link !== undefined"
            [url]="link"
            target="_blank"
            [attr.class]="'grid-link'"
            [isReadOnly]="disable"
            [matTooltip]="tooltip"
        >
            <p-icon fxLayoutAlign="center center" [name]="icon"></p-icon>
        </p-link>
    `,
    styleUrls: ['./linkable-icon-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkableIconRendererComponent implements LinkableIconRenderer {
    link!: string;
    icon!: string;
    disable!: boolean;
    tooltip = '';

    agInit(params: ICellRendererParams): void {
        const inputData = (params.colDef as ColDef).cellRendererParams;
        if (inputData) {
            const data = params.getValue?.();
            this.link = inputData.link || (data?.link && !(data?.link instanceof Function)) || data;
            this.icon = inputData.icon;
            if (inputData.disabledFun) {
                this.disable = inputData.disabledFun(data);
            }
            if (inputData.tooltipFun) {
                this.tooltip = inputData.tooltipFun(data);
            }
        }
    }

    public refresh(params: ICellRendererParams): boolean {
        return false;
    }
}
